import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireBirthInfo = false }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p className="font-serif text-2xl text-gold">Reading the stars...</p>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (requireBirthInfo && !user.has_birth_info) return <Navigate to="/onboarding" replace />;
    return children;
}
